import $ from 'jquery';

const listingConfig = window.ListingFilter || {};

// accordion-style function for mobile view
const filterHead = document.querySelectorAll('.filter-group');
filterHead.forEach(head => {
    head.addEventListener('click', function() {
        head.classList.toggle('collapsed');
    });
});

// selectors used across this module.
const selectors = {
    container: '.archive-listings',
    filterFormCourses: '.archive-listings form.filters-form.courses',
    filterFormCareers: '.archive-listings form.filters-form.careers',
    searchForm: '.archive-search',
    postTypeButtons: '.filters-top .button.__filter',
    listingsWrap: '.listings-wrap',
    paginationWrap: '.listings-pagination',
    resultsCount: '.results-count',
    resultsPage: '.results-page',
    resetButton: '.filters-header .__filter',
};

// client-side state (only post type is tracked).
const state = {
    postType: 'course',
    page: 1,
};

// resolve the currently active filter form based on the selected post type.
const getActiveFilterForm = () => {
    if (state.postType === 'career') {
        return $(selectors.filterFormCareers);
    }

    return $(selectors.filterFormCourses);
};

// reset the inactive form so its values never leak into URL state or AJAX payloads.
const resetInactiveFilterForms = () => {
    const $courseForm = $(selectors.filterFormCourses);
    const $careerForm = $(selectors.filterFormCareers);

    if (state.postType === 'career') {
        if ($courseForm.length) {
            $courseForm[0].reset();
        }
        return;
    }

    if ($careerForm.length) {
        $careerForm[0].reset();
    }
};

// clear only the filters belonging to the currently active form.
const resetActiveFilters = () => {
    const $activeForm = getActiveFilterForm();

    if (!$activeForm.length) {
        return;
    }

    $activeForm.find('input[type="checkbox"]').prop('checked', false);
};

// serialise the filter form into a payload for the AJAX endpoint.
const buildPayload = ($form) => {
    const formData = new FormData($form.get(0));

    const payload = {
        action: 'listings_filter',
        nonce: listingConfig.nonce,
    };

    formData.forEach((value, key) => {
        if (payload[key]) {
            payload[key] = Array.isArray(payload[key]) ? payload[key] : [payload[key]];
            payload[key].push(value);
        } else {
            payload[key] = value;
        }
    });

    payload.post_type = state.postType;
    payload.paged = state.page;
    payload.base_url = window.location.pathname;

    return payload;
};

// update the 'showing results' label.
const updateCount = (showingFrom, showingTo, total) => {
    const $target = $(selectors.resultsCount);
    if (!$target.length) return;
    $target.text(`Showing ${showingFrom}-${showingTo} out of ${total} posts`);
};

const updatePageLabel = (pageLabel) => {
    const $target = $(selectors.resultsPage);
    if (!$target.length) return;
    $target.text(pageLabel);
};

// read the current search term from the search form
const getSearchTerm = ($searchForm) => {
    if (!$searchForm?.length) return '';
    return ($searchForm.find('input[name="s"]').val() || '').toString().trim();
};

// build URLSearchParams from the current filters
const buildQueryParams = ($form, $searchForm) => {
    const params = new URLSearchParams();

    $form.find('input[type="checkbox"]:checked').each((_, el) => {
        params.append(el.name, el.value);
    });

    const searchTerm = getSearchTerm($searchForm);
    if (searchTerm) {
        params.set('s', searchTerm);
    }

    if (state.postType && state.postType !== 'all') {
        params.set('post_type', state.postType);
    }

    if (state.page > 1) {
        params.set('paged', state.page);
    }

    return params;
};

// replace the URL query string without reloading the page.
const updateUrl = (params) => {
    const base = window.location.pathname;
    const query = params.toString();
    const hash = window.location.hash || '';
    const nextUrl = query ? `${base}?${query}${hash}` : `${base}${hash}`;
    window.history.replaceState({}, '', nextUrl);
};

// apply URL parameters to the form state on initial load.
const applyUrlToForm = () => {
    const $courseForm = $(selectors.filterFormCourses);
    const $careerForm = $(selectors.filterFormCareers);
    const $searchForm = $(selectors.searchForm);
    if (!$courseForm.length && !$careerForm.length) return;

    const params = new URLSearchParams(window.location.search);

    const urlPostType = params.get('post_type');
    if (urlPostType) {
        state.postType = urlPostType;
    }

    const urlPage = parseInt(params.get('paged') || '1', 10);
    state.page = Number.isNaN(urlPage) ? 1 : Math.max(1, urlPage);

    // apply checkbox state from URL
    $courseForm.find('input[type="checkbox"]').each((_, el) => {
        const values = params.getAll(el.name);
        el.checked = values.includes(el.value);
    });

    $careerForm.find('input[type="checkbox"]').each((_, el) => {
        const values = params.getAll(el.name);
        el.checked = values.includes(el.value);
    });

    // apply search term from URL
    const searchTerm = params.get('s') || '';
    if ($searchForm.length) {
        $searchForm.find('input[name="s"]').val(searchTerm);
    }
    $courseForm.find('input[name="s"]').val(searchTerm);
    $careerForm.find('input[name="s"]').val(searchTerm);

    resetInactiveFilterForms();
};

// toggle active state for the post type buttons
const setActiveTypeButton = () => {
    const $buttons = $(selectors.postTypeButtons);
    const $courseForm = $(selectors.filterFormCourses);
    const $careerForm = $(selectors.filterFormCareers);

    $buttons.removeClass('is-active');
    $buttons.filter(`[data-post-type="${state.postType}"]`).addClass('is-active');

    if (state.postType === 'career') {
        $courseForm.hide();
        $careerForm.show();
        return;
    }

    $courseForm.show();
    $careerForm.hide();
};


// run the AJAX request and update the listings
const fetchResults = () => {
    const $form = getActiveFilterForm();
    const $list = $(selectors.listingsWrap);
    const $searchForm = $(selectors.searchForm);
    const $pagination = $(selectors.paginationWrap);

    if (!$form.length || !$list.length || !listingConfig.ajaxUrl) {
        return;
    }

    $list.addClass('is-loading');

    // keep hidden inputs in sync for payloads
    $form.find('input[name="s"]').val(getSearchTerm($searchForm));
    $form.find('input[name="post_type"]').val(state.postType);

    const payload = buildPayload($form);

    $.post(listingConfig.ajaxUrl, payload).done((response) => {
        if (response?.success) {
            $list.html(response.data.html || '');
            if ($pagination.length) {
                $pagination.html(response.data.pagination_html || '');
            }
            updatePageLabel(response.data.page_label || `Page ${state.page}`);
            updateCount(response.data.showing_from || 0, response.data.showing_to || 0, response.data.total || 0);
        }
    }).fail(() => {
        $list.html('<p class="listing-empty mb-0">Unable to load results right now.</p>');
        if ($pagination.length) {
            $pagination.html('');
        }
    }).always(() => {
        $list.removeClass('is-loading');
    });
};

// wire up all UI events
const bindFilters = () => {
    const $courseForm = $(selectors.filterFormCourses);
    const $careerForm = $(selectors.filterFormCareers);
    const $searchForm = $(selectors.searchForm);

    if (!$courseForm.length && !$careerForm.length) return;

    $courseForm.on('change', 'input[type="checkbox"]', () => {
        if (state.postType !== 'career') {
            state.page = 1;
            const params = buildQueryParams(getActiveFilterForm(), $searchForm);
            updateUrl(params);
            fetchResults();
        }
    });

    $careerForm.on('change', 'input[type="checkbox"]', () => {
        if (state.postType === 'career') {
            state.page = 1;
            const params = buildQueryParams(getActiveFilterForm(), $searchForm);
            updateUrl(params);
            fetchResults();
        }
    });

    $searchForm.on('submit', (e) => {
        e.preventDefault();
        state.page = 1;
        const params = buildQueryParams(getActiveFilterForm(), $searchForm);
        updateUrl(params);
        fetchResults();
    });

    $(selectors.postTypeButtons).on('click', (e) => {
        e.preventDefault();
        const type = $(e.currentTarget).data('post-type');
        state.postType = type || 'course';
        state.page = 1;
        resetInactiveFilterForms();
        setActiveTypeButton();
        const params = buildQueryParams(getActiveFilterForm(), $searchForm);
        updateUrl(params);
        fetchResults();
    });

    $(selectors.resetButton).on('click', (e) => {
        e.preventDefault();
        resetActiveFilters();
        resetInactiveFilterForms();
        state.page = 1;
        const $activeForm = getActiveFilterForm();
        $activeForm.find('input[name="post_type"]').val(state.postType);
        updateUrl(buildQueryParams($activeForm, $searchForm));
        fetchResults();
    });

    $(document).on('click', `${selectors.paginationWrap} a`, (e) => {
        const href = $(e.currentTarget).attr('href');
        if (!href) {
            return;
        }

        e.preventDefault();

        const url = new URL(href, window.location.origin);
        const nextPage = parseInt(url.searchParams.get('paged') || '1', 10);
        state.page = Number.isNaN(nextPage) ? 1 : Math.max(1, nextPage);
        updateUrl(new URLSearchParams(url.search));
        fetchResults();
    });
};

// entry point
const init = () => {
    const $container = $(selectors.container);
    if (!$container.length) return;
    state.postType = $container.data('post-type') || 'course';
    applyUrlToForm();
    bindFilters();
    setActiveTypeButton();
};

export default init;
